import styled from "@emotion/styled"
import { PTag, PText } from "@porsche-design-system/components-react"
import { colorCanvas } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"

export interface BadgeProps {
	autoWidth?: boolean
	color: string
	compact?: boolean
	label: string
}

export const Badge = ({ autoWidth, color, compact, label, ...rest }: BadgeProps) => (
	<StyledTag title={label} $color={color} compact={compact} {...rest}>
		{autoWidth ? (
			label
		) : (
			<StyledText color="inherit" size="xs" ellipsis>
				{label}
			</StyledText>
		)}
	</StyledTag>
)

const StyledTag = styled(PTag, { shouldForwardProp })<{ $color: string }>`
	--p-color-frosted-strong: ${({ $color }) => $color};
	--p-color-primary: ${colorCanvas};
`

const StyledText = styled(PText)<{ $autoWidth?: boolean }>`
	${({ $autoWidth }) => !$autoWidth && "max-width: 76px;"}
	color: ${colorCanvas};
`
